(function ($) {
  const tilt = $(".js-tilt").tilt({
    maxTilt: 5,
    perspective: 800,
  });

  const tiltCards = $(".js-tilt-card").tilt({
    maxTilt: 10,
    perspective: 800,
  });
})(jQuery);
